<template>
  <div class="friend">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <img class="card-icon" src="../assets/lianjie.png" />
        <span>{{"友链"}}</span>
        <el-button style="float: right; padding: 3px 0" type="text">
          <router-link to="/apply">{{"友链互换"}}</router-link>
        </el-button>
      </div>
      <div class="text item">
        <div v-if="linksListCount==0">
          {{"暂无数据"}}
        </div>
        <el-link class="f-links" v-for="(item,index) in linksList" :key="item.id" :value="item" :href="item.websiteLink" :underline="false" :type="typeList[index%typeList.length]" target="_blank">{{item.websiteName}}</el-link>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "friend",
  data() {
    return {
      typeList: ["primary", "success", "warning", "danger", "info"],
    };
  },
  computed: {
    linksListCount() {
      return this.$store.state.linksList.length;
    },
    linksList() {
      return this.$store.state.linksList;
    },
  },
};
</script>

<style scoped>
.f-links {
  margin-right: 10px;
}

.box-card .item a {
  text-decoration: none;
  /*color: #F56C6C;*/
}
.box-card span {
  font-weight: bold;
}
.card-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.friend {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>